import classNames from 'classnames'
import type { FC } from 'react'
import styles from './Avatar.module.scss'
import type { AvatarProps } from './types'
import { AvatarShape, AvatarSize, AvatarStyle } from './types'

const Avatar: FC<AvatarProps> = ({
  className,
  label = '',
  shape = AvatarShape.square,
  size = AvatarSize.medium,
  style = AvatarStyle.neutral,
  loading = false,
  imgSrc,
  imgAlt,
  accessory: AccessoryComponent,
  ...props
}) => {
  const unset = !label && !imgSrc
  return (
    <div
      className={classNames(styles['pintxo-avatar'], className)}
      data-size={size}
      data-shape={shape}
    >
      <div
        className={styles['pintxo-avatar__shape']}
        data-shape={shape}
        data-size={size}
        data-unset={unset}
        data-loading={loading}
        data-style={style}
        {...props}
      >
        {imgSrc ? (
          <img alt={imgAlt} src={imgSrc} />
        ) : (
          label && <span className={styles['pintxo-avatar__shape__text']}>{label}</span>
        )}
      </div>
      {AccessoryComponent}
    </div>
  )
}

export default Avatar
